import axios from 'axios'
import { TROCAR_POLTRONA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function trocarPoltrona (parametros) {
  const url = `${URL}/reserva/trocar-poltrona`;
  return dispatch => axios.post(url,parametros , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: TROCAR_POLTRONA,
        payload: response
      })
  );
}
